import { render, staticRenderFns } from "./TeamTax.vue?vue&type=template&id=6f69856d&scoped=true&"
import script from "./TeamTax.vue?vue&type=script&lang=js&"
export * from "./TeamTax.vue?vue&type=script&lang=js&"
import style0 from "./TeamTax.vue?vue&type=style&index=0&id=6f69856d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69856d",
  null
  
)

export default component.exports